<template>
  <Modal v-model="visible" :title="$t(`${modelTitle}`)" :width="500" :mask-closable="false" @on-cancel="closeModal">
    <div class="content-wrapper">
      <section class="type-wrapper">
        <RadioGroup
          v-model="activeTab"
          type="button"
          button-style="solid"
          class="radios-container"
          @on-change="changeTab"
        >
          <Radio v-for="item in uploadTypes" :key="item.value" :label="item.value" class="item--radio">
            {{ item.label }}
          </Radio>
        </RadioGroup>
      </section>

      <Form ref="fileRef" :model="fileContent" :rules="rules">
        <!-- 1. file content -->
        <FormItem
          v-if="activeTab === uploadTypes[0].value"
          :label="$t('upload.fileContent')"
          prop="content"
          class="code-editor-wapper"
        >
          <UploadFile
            :accept="textFileAccept"
            class="upload-file editor-upload-file--btn"
            @handleUpload="getFileContent"
          >
            <template v-slot:text>
              <Button type="text" class="upload-file--link">{{ $t('upload.uploadFile') }}</Button>
            </template>
          </UploadFile>
          <div class="monaco-container code-container">
            <Monaco v-if="visible" id="file-data" v-model="fileContent.content" lang="json"></Monaco>
          </div>
        </FormItem>
        <!-- 2. file URL(uploaded file) -->
        <FormItem v-if="activeTab === uploadTypes[1].value" :label="$t('upload.fileURL')" prop="file">
          <UploadedFilesSelector v-model="fileContent.file" :filterable="true" :allowCreate="true" />
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button type="text" @click="closeModal">{{ $t('common.cancel') }}</Button>
      <Button :loading="isUploading" type="primary" @click="submit">
        {{ $t('common.submit') }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import upload from '@/mixins/upload'
import Monaco from '@/components/Monaco'
import UploadFile from '@/views/configuration/uploads/components/UploadFile.vue'
import UploadedFilesSelector from '@/components/UploadedFilesSelector.vue'

export default {
  name: 'ImportFileModel',

  props: {
    modalVisible: { type: Boolean, deafult: false },
    fileAccepts: { type: String, deafult: '-' },
    title: { type: String, deafult: '' },
    isUploading: { type: Boolean, deafult: false },
  },

  mixins: [upload],

  components: { UploadFile, Monaco, UploadedFilesSelector },

  data() {
    return {
      uploadTypes: [
        {
          value: 'text',
          label: this.$t('nodes.importText'),
        },
        {
          value: 'url',
          label: this.$t('nodes.importURL'),
        },
      ],
      activeTab: 'text',
      textFileAccept: 'text/plain, application/x-yaml, application/json, application/javascript',
      fileContent: {
        content: '', // text content
        file: '', // url
      },
      rules: {
        file: [{ required: true, message: this.$t('upload.fileURLRequied'), trigger: 'blur' }],
        content: [{ required: true, message: this.$t('upload.fileContentRequried') }],
      },
    }
  },
  computed: {
    visible: {
      get() {
        if (!this.modalVisible) {
          this.resetData()
        }
        return this.modalVisible
      },
      set(val) {
        this.$emit('update:modalVisible', val)
      },
    },
    modelTitle() {
      return this.title || 'rules.importRules'
    },
  },

  methods: {
    changeTab() {
      // clear error status:Since `v-if`, file and conteng form item are the first position,so index are 0
      this.$refs.fileRef.fields[0].validateState = ''
    },

    getFileContent(file) {
      this.readFile(file).then((res) => {
        this.fileContent.content = res
      })
    },

    closeModal() {
      this.visible = false
      this.resetData()
      this.$emit('close')
    },

    resetData() {
      this.activeTab = 'text'
      this.fileContent = { content: '', file: '' }
    },

    submit() {
      this.$refs.fileRef.validate((valid) => {
        if (valid) {
          const data = {}
          const { content, file } = this.fileContent
          if (this.activeTab === this.uploadTypes[0].value) {
            data.content = content
          } else {
            data.file = file
          }
          this.$emit('submit', data)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.type-wrapper {
  margin-bottom: 16px;
  .radios-container {
    margin-top: 10px;
    width: 100%;
    display: flex;
  }
  .item--radio {
    flex: 1;
    text-align: center;
  }
}

.content-wrapper {
  width: 100%;
  padding: 16px 16px 0;
}

.code-editor-wapper {
  .item-container {
    margin-bottom: 10px;
  }
  .editor-upload-file--btn {
    text-align: right;
  }
  .upload-file--link {
    display: inline-block;
    padding-right: 0;
  }
  ::v-deep .form-item--code {
    margin-bottom: 0;
  }
  .code-container,
  #monaco-file-data {
    min-height: 200px;
    width: 100%;
  }
}
</style>
